'use client'

import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import createFacetFiltersFromSlug from '@modules/trials/search/facetFilters/createFacetFiltersFromSlug'
import omit from 'lodash/omit'
import { usePathname, useSearchParams } from 'next/navigation'

export function FilterTotalCount() {
  const searchParams = useSearchParams()
  const pathname = usePathname()

  const { treatment } = createFacetFiltersFromSlug(pathname ?? '')
  const activePrimaryFilters = treatment ? 1 : 0
  // Get all search params but exclude the UI control params (showMap and showFilters)
  const paramsObject = Object.fromEntries(searchParams ?? new URLSearchParams())

  const activeFilterCount = Object.keys(
    omit(paramsObject, ['showMap', 'showFilters', 'page']),
  ).length

  const totalFilterCount = activePrimaryFilters + activeFilterCount

  return (
    <div
      className={classMerge(
        'ml-1 mt-0.5 hidden size-4 items-center justify-center rounded-full bg-primary100',
        totalFilterCount > 0 && 'flex',
      )}
    >
      <Text
        className=' text-primary800'
        element='p'
        styleName='p-xxtiny-strong'
      >
        {totalFilterCount}
      </Text>
    </div>
  )
}
